import {Memo as MemoComponent, Item} from './Memo'
import {Icon} from './Icon'
import {Modal} from './Modal'

export const Memo = Object.assign(MemoComponent, {Icon, Modal, Item})
